
import { create } from 'zustand';

export const useControlRoomStore = create((set, get) => ({
  viewState: 'default',
  primaryMetric: 'hot-rate',
  autoDetect: true,
  channel: 'sms', // 'sms' | 'web'
  setChannel: (channel) => set({ channel, viewState: 'default', autoDetect: true }),
  
  thresholds: {
    hotSpikeRate: 35,
    highVolume: 1500,
    quietPeriod: 300,
    criticalHotRate: 50,
  },
  
  setViewState: (state) => set({ viewState: state }),
  
  setPrimaryMetric: (metric) => set({ primaryMetric: metric }),
  
  toggleAutoDetect: () => set((state) => ({ autoDetect: !state.autoDetect })),
  
  updateThresholds: (newThresholds) => 
    set((state) => ({ 
      thresholds: { ...state.thresholds, ...newThresholds } 
    })),
  
  detectState: (metrics) => {
    const { autoDetect, thresholds } = get();
    
    if (!autoDetect) return;
    
    if (metrics.hotLeadRate > thresholds.hotSpikeRate) {
      set({ 
        viewState: 'hot-spike',
        primaryMetric: 'hot-rate'
      });
      return 'hot-spike';
    }
    
    if (metrics.messageVolume > thresholds.highVolume) {
      set({ 
        viewState: 'high-volume',
        primaryMetric: 'volume'
      });
      return 'high-volume';
    }
    
    if (metrics.messageVolume < thresholds.quietPeriod) {
      set({ 
        viewState: 'quiet',
        primaryMetric: 'hot-rate'
      });
      return 'quiet';
    }
    
    set({ 
      viewState: 'default',
      primaryMetric: 'hot-rate'
    });
    return 'default';
  },
  
  setManualState: (state) => {
    set({ 
      viewState: state,
      autoDetect: false 
    });
  },
  
  reset: () => {
    set({
      viewState: 'default',
      primaryMetric: 'hot-rate',
      autoDetect: true
    });
  }
}));